const origins = ['customer', 'remind', 'workbench', 'schedule', 'daily-brief']
const customerPages = ['customer-detail', 'customer-edit']

// Track only this app's customer journey, rather than guessing from browser history.length.
export function recordCustomerJourney(store, to, from) {
  let journey = store.state.customerJourney
  if (origins.indexOf(from.name) >= 0 && customerPages.indexOf(to.name) >= 0) {
    store.commit('setCustomerJourney', { origin: from.fullPath, customerId: String(to.params.id), paths: [from.path, to.path] })
    return
  }
  if (!journey) return
  if (customerPages.indexOf(to.name) < 0 || String(to.params.id) !== journey.customerId) {
    store.commit('setCustomerJourney', null)
    return
  }
  const index = journey.paths.indexOf(to.path)
  const paths = index >= 0 ? journey.paths.slice(0, index + 1) : journey.paths.concat(to.path)
  store.commit('setCustomerJourney', Object.assign({}, journey, { paths }))
}

export function returnToCustomerOrigin(vm, fallback) {
  const journey = vm.$store.state.customerJourney
  if (journey && String(vm.$route.params.id) === journey.customerId && journey.paths[journey.paths.length - 1] === vm.$route.path) {
    vm.$router.go(1 - journey.paths.length)
  } else vm.$router.replace(fallback)
}



// WEBPACK FOOTER //
// ./src/common/customer-return.js